import { LinkBankFormErrorModel } from '@shared/system-components/link-bank-widget/model/form-error.model';

class ErrorModalController {
  $onInit() {
    $('#errorModal').on('hidden.bs.modal', () => {
      this.onClosed();
    });

    this.error = new LinkBankFormErrorModel();
  }
}

export default ErrorModalController;



// WEBPACK FOOTER //
// ./client/app/pages/settings/component/bank-account/error.modal.controller.js